import { TWebchatVisitorType } from 'modules/webchat/domain/entities';
import { IWebchatVisitorsRepository } from 'modules/webchat/domain/repositories';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

const VISITOR_TYPES: TWebchatVisitorType[] = ['cliente', 'cadastrado', 'novo'];

const isVisitorType = (value: unknown): value is TWebchatVisitorType =>
  VISITOR_TYPES.includes(value as TWebchatVisitorType);

export default class VectisWebchatVisitorsRepository
  implements IWebchatVisitorsRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public identify: IWebchatVisitorsRepository['identify'] = async ({
    phone,
  }) => {
    const response = await this.httpProvider.post<{ tipo?: unknown } | null>(
      'chat/identificacao',
      { telefone: phone },
    );

    const type = response?.tipo;

    return isVisitorType(type) ? type : null;
  };
}
